import { render, staticRenderFns } from "./diagnosis-form-component.vue?vue&type=template&id=795fdd7d"
import script from "./diagnosis-form-component.vue?vue&type=script&lang=js"
export * from "./diagnosis-form-component.vue?vue&type=script&lang=js"
import style0 from "./diagnosis-form-component.vue?vue&type=style&index=0&id=795fdd7d&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "@/locale/diagnosis-form-component-localization.json?vue&type=custom&index=0&blockType=i18n&issuerPath=C%3A%5CUsers%5Cnikod%5CDocuments%5Cgithub%5Cnikodz%5CWebmed.Core.VueJS%5Csrc%5Ccomponent%5Cdiagnosis-form-component.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports